module.exports = __webpack_public_path__ + "static/media/RemoteAdventures_Logo.8378a807.png";